import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import AppSection from '@/pages/home/components/AppSection';
import IndexSection from '@/pages/home/components/IndexSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CardsSection from '@/pages/home/components/CardsSection';
import MediaSection from '@/pages/home/components/MediaSection';
import AboutSection from '@/pages/home/components/AboutSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import FaqSection from '@/pages/home/components/FaqSection';
import ContactSection from '@/pages/home/components/ContactSection';
import RankingSection from '@/pages/home/components/RankingSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <AppSection />
        <IndexSection />
        <FeaturesSection />
        <CardsSection />
        <MediaSection />
        <AboutSection />
        <CarouselSection />
        <FaqSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}